import SettingController from "./SettingController";
import { DEFAULT_THEME, enumerateThemes } from "../../theme";
import { type SettingLevel } from "../SettingLevel";

export default class ThemeController extends SettingController {
    public static isLogin = false;

    public getValueOverride(
        level: SettingLevel,
        roomId: string,
        calculatedValue: any,
        calculatedAtLevel: SettingLevel | null,
    ): any {
        if (!calculatedValue) return null; // Don't override null themes

        // if (ThemeController.isLogin) return "light";

        const themes = enumerateThemes();
        // Override in case some no longer supported theme is stored here
        if (!themes[calculatedValue]) {
            return DEFAULT_THEME;
        }

        return null; // no override
    }
}
